// src/assets/gallery-reorder.js
// Reine, DOM-freie Reorder-Logik für die PDP-Farb-Galerie (TODO 6).
// Tests via node:test. Browser-Bridge unten (analog variant-cards.js).

export function normalizeColor(raw) {
  return String(raw == null ? '' : raw).trim().toLowerCase();
}

/**
 * Medien (Base-Reihenfolge) nach gewählter Farbe umsortieren.
 * @param {Array<{id:string,color:string}>} items - base-geordnete Medien
 * @param {string} selectedColor
 * @returns {Array<string>} IDs: gematchte Farbe zuerst (stabil), Rest danach (stabil)
 */
export function orderByColor(items, selectedColor) {
  const list = Array.isArray(items) ? items : [];
  const want = normalizeColor(selectedColor);
  if (!want) return list.map((m) => m.id);
  const matched = [];
  const rest = [];
  for (const m of list) {
    if (normalizeColor(m.color) === want) matched.push(m.id);
    else rest.push(m.id);
  }
  return [...matched, ...rest];
}

/**
 * Medien nach gewählter Farbe FILTERN (nicht nur sortieren):
 * sichtbar = Bilder der gewählten Farbe + farb-neutrale Bilder (color === '').
 * Andere Farben werden ausgeblendet. Gematchte Farbe zuerst, dann neutrale.
 *
 * Fallback (filtered=false → alle Bilder zeigen):
 *  - keine Farbe gewählt, ODER
 *  - kein einziges Bild trägt die gewählte Farbe (sonst bliebe evtl. nur 0–1 Bild).
 *
 * @param {Array<{id:string,color:string}>} items - base-geordnete Medien
 * @param {string} selectedColor
 * @returns {{ids:string[], filtered:boolean}} ids = sichtbare Medien in Anzeige-Reihenfolge
 */
export function visibleByColor(items, selectedColor) {
  const list = Array.isArray(items) ? items : [];
  const want = normalizeColor(selectedColor);
  const allIds = list.map((m) => m.id);
  if (!want) return { ids: allIds, filtered: false };
  const hasColorImages = list.some((m) => normalizeColor(m.color) === want);
  if (!hasColorImages) return { ids: allIds, filtered: false };
  const matched = [];
  const neutral = [];
  for (const m of list) {
    const c = normalizeColor(m.color);
    if (c === want) matched.push(m.id);
    else if (c === '') neutral.push(m.id);
    // andere Farbe → ausgeblendet
  }
  return { ids: [...matched, ...neutral], filtered: true };
}

/**
 * Thumbnail-IDs, die beim Farb-Filter aus dem DOM gelöst werden müssen = alle
 * vorhandenen Thumbnails minus die sichtbaren.
 *
 * Wichtig bei hide_variants=true: andersfarbige Variant-Bilder tragen KEIN
 * .product-media-main (stehen daher nicht in baseMediaItems/visibleIds), aber ein
 * Thumbnail. Ohne dieses explizite Entfernen bliebe z.B. das schwarze Variant-Thumbnail
 * im DOM, rutschte nach dem Reorder auf :first-child (CSS-Hide
 * `.product-media-thumbnail-variant:not(:first-child)` greift dann nicht mehr → sichtbar)
 * und hätte keinen Klick-Handler (im Constructor nur an nicht-variant/first-child gebunden).
 *
 * @param {string[]} allThumbIds - alle vorhandenen Thumbnail-Media-IDs
 * @param {string[]} visibleIds - sichtbare IDs (visibleByColor-Ergebnis)
 * @returns {string[]} zu entfernende IDs (stabile Reihenfolge)
 */
export function thumbnailIdsToDetach(allThumbIds, visibleIds) {
  const show = new Set(Array.isArray(visibleIds) ? visibleIds : []);
  return (Array.isArray(allThumbIds) ? allThumbIds : []).filter((id) => !show.has(id));
}

// Browser-Bridge: media-gallery.js (klassisches Script) liest window.CECGalleryReorder.
if (typeof window !== 'undefined') {
  window.CECGalleryReorder = {
    normalizeColor,
    orderByColor,
    visibleByColor,
    thumbnailIdsToDetach,
  };
}
